export default __webpack_public_path__ + "pgnv-assets/8353c08b02ca237607b1af214c90302c.png";